// There's no meaningful non-JS fallback here (the whole point is fetching
// smarter, purchase-data-driven picks from Shopify's own recommendation
// engine), so this section renders empty until the fetch below completes.
// Waits until the section is nearly in view before fetching, rather than
// on every product page load regardless of whether anyone scrolls that far.
class ProductRecommendations extends HTMLElement {
  constructor() {
    super();

    const observer = new IntersectionObserver((entries) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      this.load();
    }, { rootMargin: '0px 0px 200px 0px' });

    observer.observe(this);
  }

  async load() {
    const url = this.dataset.url;
    if (!url) return;

    try {
      const response = await fetch(url);
      const text = await response.text();
      const parsed = new DOMParser().parseFromString(text, 'text/html');
      const newContent = parsed.querySelector('product-recommendations');

      if (newContent && newContent.innerHTML.trim().length) {
        this.innerHTML = newContent.innerHTML;
      } else {
        // No recommendations for this product (e.g. too new, not enough
        // data yet) - remove the empty shell instead of leaving a gap.
        this.remove();
      }
    } catch (error) {
      this.remove();
    }
  }
}

customElements.define('product-recommendations', ProductRecommendations);
